<template>
  <div class="header-main">
    <Transition name="slide-down" mode="out-in">
      <div v-if="isShowFullHeader" key="full" class="header-main__bg">
        <AppHeaderFull />

        <ClientOnly>
          <NotificationPanel
            v-if="isShowNotificationPanel"
            ref="notificationPanel"
            full
            @changeAlert="setNotificationPanelHeight"
          />
        </ClientOnly>
      </div>

      <div v-else key="smart">
        <ClientOnly>
          <NotificationPanel
            v-if="isShowNotificationPanel"
            ref="notificationPanel"
            full
            @changeAlert="setNotificationPanelHeight"
          />
        </ClientOnly>

        <AppHeaderSmart />
      </div>
    </Transition>
    <ClientOnly>
      <BalanceDropdown v-if="isDropdownOpen.balance && isLoggedIn" />
    </ClientOnly>
  </div>
</template>

<script>
import AppHeaderFull from './Full'
import AppHeaderSmart from './Smart'
import NotificationPanel from '@/components/NotificationPanel'
import { mapGetters, mapActions } from 'vuex'
import { HEADER } from './enum'
import BalanceDropdown from '~/components/App/AppHeader/BalanceDropdown'
export default {
  name: 'AppHeader',
  components: {
    BalanceDropdown,
    AppHeaderFull,
    AppHeaderSmart,
    NotificationPanel,
  },
  data() {
    return {
      previousScrollPos: 0,
      threshold: 10,
      ticking: false, // to prevent multiple rAF calls
      tickingResize: false,
      HEADER,
    }
  },
  computed: {
    ...mapGetters('base', ['get_header', 'isDropdownOpen']),
    ...mapGetters('user', ['isUserLoaded', 'isLoggedIn', 'isUserVerified']),
    ...mapGetters('limits', ['get_limitsIsLoaded', 'get_isLimitsHasBeenSet']),
    isShowFullHeader() {
      return this.get_header === HEADER.FULL
    },
    isShowNotificationPanel() {
      if (!this.isUserLoaded || !this.get_limitsIsLoaded || !this.isLoggedIn) return false
      return !this.isUserVerified || !this.get_isLimitsHasBeenSet
    },
  },
  watch: {
    isShowNotificationPanel: {
      handler(val) {
        if (process.client) {
          if (val) {
            this.setNotificationPanelHeight()
            window.addEventListener('resize', this.onResize)
          }
          else {
            this.setPropertyHeight('0px')
            window.removeEventListener('resize', this.onResize)
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.previousScrollPos = window.scrollY
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions('base', ['act_setHeader']),
    onScroll() {
      // If a frame request is already scheduled, don't queue another
      if (!this.ticking) {
        this.ticking = true
        requestAnimationFrame(() => {
          this.handleScroll()
          this.ticking = false
        })
      }
    },
    async handleScroll() {
      const currentScrollPos = window.scrollY

      if ((currentScrollPos - this.previousScrollPos) > this.threshold && HEADER.FULL) {
        // Scrolling down more than threshold
        await this.act_setHeader({ type: HEADER.SMART })
      }
      else if ((this.previousScrollPos - currentScrollPos) > this.threshold && HEADER.SMART) {
        // Scrolling up more than threshold
        await this.act_setHeader({ type: HEADER.FULL })
      }

      this.previousScrollPos = currentScrollPos
    },
    setPropertyHeight(height) {
      document.body.style.setProperty('--notification-panel-height', height)
    },
    setNotificationPanelHeight() {
      this.$nextTick(() => {
        const notificationPanel = this.$refs.notificationPanel?.$el

        if (!notificationPanel) return

        const notificationPanelHeight = notificationPanel.offsetHeight
        this.setPropertyHeight(`${notificationPanelHeight}px`)
      })
    },
    handleResize() {
      this.setNotificationPanelHeight()
    },
    onResize() {
      if (!this.tickingResize) {
        this.tickingResize = true

        requestAnimationFrame(() => {
          this.handleResize()
          this.tickingResize = false
        })
      }
    },
  },

}
</script>
<style lang="scss" scoped src="./style.scss" />
